import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useWindowDimensions } from "./window-dimensions";

const useStyles = makeStyles((theme) => ({
  whole: {
    width: "100%",
    overflowX: "auto",
  },
  row: {
    marginBottom: 10,
    display: "flex",
    flexDirection: "row",
    flex: 1,
    fontSize: 12,
  },
  first: {
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    height: "40px",
    flex: 0.5,
    alignItems: "center",
    clipPath: "polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%)",
    background: "#1D3557",
    color: "white",
    paddingRight: "3%",
    wordWrap: "break-word",
    cursor: "pointer",
  },
  other: {
    justifyContent: "center",
    textAlign: "center",
    display: "flex",
    height: "40px",
    flex: 0.5,
    alignItems: "center",
    clipPath: "polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%)",
    background: "#1D3557",
    color: "white",
    paddingRight: "5%",
    paddingLeft: "5%",
    wordWrap: "break-word",
    cursor: "pointer",
  },
}));

const CustomLabel = ({ arr, style }) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();

  return (
    <div className={classes.whole} style={style}>
      <div className={classes.row}>
        {arr.map((item, index) =>
          item.name === "" || !item.name ? null : index === 0 ? (
            <div
              className={classes.first}
              style={{
                maxWidth: width < 450 ? "50%" : width < 350 ? "40%" : "30%",
                backgroundColor: !arr[index + 1]
                  ? "#1D3557"
                  : !arr[index + 1].name
                  ? "#1D3557"
                  : "#457B9D",
              }}
              key={item.id}
              onClick={item.onClick}
            >
              {item.name}
            </div>
          ) : (
            <div
              key={item.id}
              className={classes.other}
              style={{
                maxWidth: width < 450 ? "50%" : width < 350 ? "40%" : "30%",
              }}
              onClick={item.onClick}
            >
              {item.name}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CustomLabel;
